export default __webpack_public_path__ + "static/media/uploadMalay.2b92e144.png";